// Copyright 2026 AllSpice. All rights reserved. Not Gitea.
// SPDX-License-Identifier: UNLICENSED

// Save text the page already holds as a file, without a round trip to the
// server.
export function downloadTextFile(filename: string, content: string, mediaType: string): void {
  const url = URL.createObjectURL(new Blob([content], {type: mediaType}));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
